import { createRelayEnvironment } from './createRelayEnvironment';
export var AtlassianRelayEnvironment = createRelayEnvironment({});